import { localeReducer } from './locale';
import { screenReducer } from './screen';
import { userReducer } from './user';
import type {
  ActiveFeatureConfigAction,
  GlobalContextAction,
  GlobalContextReducerState,
  LocaleAction,
  NavbarStateAction,
  RBACPermissionsAction,
  RBACRedirectConfigAction,
  ReportRegenerationModalAction,
  ScreenAction,
  ToastAction,
  UserAction
} from './types';
import { toastReducer } from './toast';
import { permissionReducer } from './permission';
import { routeConfigReducer } from './routeConfig';
import { caseHistoryReducer } from './case-history';
import type { CaseHistoryModalAction } from './case-history/caseHistory.types';
import { navbarStateReducer } from './navbarOpenState';
import { activeFeatureConfigReducer } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { reportRegenerationModalReducer } from './reportRegenerationModalState';

export const rootReducer = (
  {
    screen,
    locale,
    user,
    toast,
    navbarState,
    permissions,
    routeConfig,
    caseHistoryModal,
    activeFeatureConfig,
    isReportRegenerationModalOpen
  }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  screen: screenReducer(screen, action as ScreenAction),
  locale: localeReducer(locale, action as LocaleAction),
  user: userReducer(user, action as UserAction),
  toast: toastReducer(toast, action as ToastAction),
  navbarState: navbarStateReducer(navbarState, action as NavbarStateAction),
  permissions: permissionReducer(permissions, action as RBACPermissionsAction),
  routeConfig: routeConfigReducer(
    routeConfig,
    action as RBACRedirectConfigAction
  ),
  caseHistoryModal: caseHistoryReducer(
    caseHistoryModal,
    action as CaseHistoryModalAction
  ),
  activeFeatureConfig: activeFeatureConfigReducer(
    activeFeatureConfig,
    action as ActiveFeatureConfigAction
  ),
  portal: Portal.OPS,
  isReportRegenerationModalOpen: reportRegenerationModalReducer(
    isReportRegenerationModalOpen,
    action as ReportRegenerationModalAction
  )
});
